import React, { useContext, useEffect, useState } from "react";

import contactUsStyle from "./ContactUs.module.scss";
import classnames from "classnames";
import { useTranslation } from "next-i18next";
import { AppContext } from "@vahak/core/dist/app-context";
import { copyToClipboard } from "@vahak/core/dist/methods/copyToClipboard";

import ContactUsCard from "./ContactCard/ContactCard";
import WhatsappSymbol from "@vahak/core/dist/icons/WhatsappSymbol.svg";
import Telephone from "@vahak/core/dist/icons/telephone.svg";
import Phones from "@vahak/core/dist/icons/Phones.svg";
import Gmail from "@vahak/core/dist/icons/Gmail.svg";
import Located from "../../careers/located/Located";
import CardContainer from "@vahak/core/dist/components/responsive-container/ResponsiveContainer";
import A from "@vahak/core/dist/components/app-anchor/A";
import PageMetaTags from "../../common/page-meta-tags/PageMetaTags";
import dynamic from "next/dynamic";

// Constants
import { VAHAK_EMAIL, VAHAK_EMAIL_INFO } from "@vahak/core/dist/constants/misc";
import { COMPANY_DETAILS } from "@vahak/core/dist/constants/companyDetails";
import { useToggleCBRModal } from "../../../hooks/useCallbackRequestedState";
import { CONTACT_US_CALL_BACK_REQUEST } from "constants/modal-strings";
import { useToggleModal } from "hooks/useToggleModal";
import { useRouter } from "next/router";
import { CallMeBackScreen } from "@vahak/core/dist/_services/callMeBack.service";

const CallbackRequest = dynamic(
    () =>
        import(
            /* webpackChunkName: "CallbackRequestModal", webpackPrefetch: true */ "../callback-request/CallbackRequest"
        ).catch(() => {
            return () => <></>;
        }),
    { ssr: false }
);

const ContactUsComponent = () => {
    const { t } = useTranslation(["contactus"]);
    const { isMobile } = useContext(AppContext);
    const { toggleCBRModal } = useToggleCBRModal();
    // const [isCallbackRequestPopupVisible, setisCallbackRequestPopupVisible] = useState(false);
    const { openModal: openLoadBidModal, closeModal: closeLoadBidModal } = useToggleModal(CONTACT_US_CALL_BACK_REQUEST);
    const router = useRouter();
    // const onClickWhatsapp = () => {
    //     window.open(
    //         isMobile ? VAHAK_WHATSAPP_LINK_MOBILE : VAHAK_WHATSAPP_LINK_DESKTOP,
    //         "_blank",
    //         "noopener noreferrer"
    //     );
    // };
    const toggleCallBackRequestModal = () => {
        if (!router.asPath.includes(CONTACT_US_CALL_BACK_REQUEST)) {
            if (toggleCBRModal()) {
                openLoadBidModal();
            }
        } else {
            closeLoadBidModal();
        }
    };
    const onClickEmail = () => {
        copyToClipboard(VAHAK_EMAIL, "Email Id copied!");
        // if (isMobile) {
        //     window.open(`mailto:${VAHAK_EMAIL}`, "_blank", "noopener noreferrer");
        // } else {
        //     copyToClipboard(VAHAK_EMAIL, "Email Id copied!");
        // }
    };

    const onClickEmail_Info = () => {
        if (isMobile) {
            window.open(`mailto:${VAHAK_EMAIL_INFO}`, "_blank", "noopener noreferrer");
        } else {
            copyToClipboard(VAHAK_EMAIL_INFO, "Email Id copied!");
        }
    };

    const onClickPhone = () => {
        if (isMobile) {
            window.open(`tel:${COMPANY_DETAILS.telephone}`, "_self");
        } else {
            copyToClipboard(COMPANY_DETAILS.telephone, "Phone number copied!");
        }
    };

    useEffect(() => {
        // window.prerenderReady = true;
    }, []);

    const description =
        "Get in touch with us for any kind of LCV, truck, or container related queries. Contact us at +91-8035738071 or email us at cs@vahak.in";

    return (
        <>
            <PageMetaTags
                title="Vahak - Contact Us"
                description={description}
                keywords="find truck loads online, vahak, vahak app, truck loads app, book my truck,transportation apps in india"
                canonicalUrl="https://www.vahak.in/contact-us"
                ogUrl="https://www.vahak.in/contact-us"
                ogImgAltText={description}
                schemaOrgJsonUrl="/contact-us"
                includeDefaultSchema={false}
                schemaType="WebPage"
            />
            <div
                className={classnames(isMobile ? contactUsStyle.contactUs__mob : contactUsStyle.contactUs__web)}
                style={{
                    marginTop: isMobile ? "55px" : "74px"
                    //getHeightByViewPort(74)
                }}
            >
                <header
                    className={classnames(
                        contactUsStyle.headerBaground,
                        isMobile ? contactUsStyle.header__mob : contactUsStyle.header__web
                    )}
                >
                    <h1
                        className={classnames(
                            contactUsStyle.textCommon,
                            isMobile ? contactUsStyle.headingText__mob : contactUsStyle.headingText__web
                        )}
                    >
                        {isMobile ? t("contactus:contactUs") : <h1> {t("contactus:contactUs")}</h1>}
                    </h1>
                    <h2
                        className={classnames(
                            contactUsStyle.textCommon,
                            isMobile ? contactUsStyle.headingSubText__mob : contactUsStyle.headingSubText__web
                        )}
                    >
                        {isMobile ? (
                            `${t("contactus:getintouchand_letusknow_queries")}`
                        ) : (
                            <h2>{t("contactus:getintouchand_letusknow_queries")} </h2>
                        )}
                    </h2>
                </header>
                <CardContainer
                    className={classnames(isMobile ? contactUsStyle.cardargin__mob : contactUsStyle.cardargin__web)}
                >
                    {/* <section className={classnames(contactUsStyle.commonMargin)}> */}
                    {/* <ContactUsCard
                        heading={t("contactus:contactus_card.whatsapp")}
                        contentText={t("contactus:contactus_card.whatsapp_text")}
                        footerText="+91-"
                        className={contactUsStyle.card}
                        icon={
                            <WhatsappSymbol
                                className={classnames(isMobile ? contactUsStyle.iconmob : contactUsStyle.iconweb)}
                            />
                        }
                        onClickCard={onClickWhatsapp}
                    /> */}
                    {/* <ContactUsCard
                        heading={t("contactus:contactus_card.emailus")}
                        contentText={t("contactus:contactus_card.emailus_text")}
                        footerText={t("contactus:contactus_card.click_tocopy_email")}
                        className={contactUsStyle.card}
                        icon={
                            <Gmail className={classnames(isMobile ? contactUsStyle.iconmob : contactUsStyle.iconweb)} />
                        }
                        onClickCard={onClickEmail}
                    /> */}
                    <ContactUsCard
                        heading={t("contactus:contactus_card.request_call_back")}
                        contentText={t("contactus:contactus_card.request_call_back_text")}
                        specialText={COMPANY_DETAILS.openHours}
                        footerText={t("contactus:contactus_card.raise_callback_request")}
                        className={contactUsStyle.card}
                        icon={
                            <Telephone
                                className={classnames(isMobile ? contactUsStyle.iconmob : contactUsStyle.iconweb)}
                            />
                        }
                        onClickCard={toggleCallBackRequestModal}
                    />
                    <ContactUsCard
                        heading={t("contactus:contactus_card.call_us")}
                        contentText={t("contactus:contactus_card.call_us_text")}
                        specialText={COMPANY_DETAILS.openHours}
                        footerText={COMPANY_DETAILS.telephone}
                        className={contactUsStyle.card}
                        icon={
                            <Phones
                                className={classnames(isMobile ? contactUsStyle.iconmob : contactUsStyle.iconweb)}
                            />
                        }
                        onClickCard={onClickPhone}
                    />
                    {/* </section> */}
                </CardContainer>
                <div className={classnames(contactUsStyle.centerDiv)}>
                    <div
                        className={classnames(
                            isMobile ? contactUsStyle.centerDiv_align__mob : contactUsStyle.centerDiv_align__web
                        )}
                    >
                        <div>
                            <A onClick={onClickEmail}>
                                <h3
                                    className={classnames(
                                        contactUsStyle.centerTextCommon,
                                        isMobile
                                            ? contactUsStyle.centerTextCommon__text__mob
                                            : contactUsStyle.centerTextCommon__text__web
                                    )}
                                >
                                    {" "}
                                    {t("contactus:general_communication")}
                                </h3>
                                <div
                                    className={classnames(
                                        contactUsStyle.centercontentCommon,
                                        isMobile
                                            ? contactUsStyle.centercontentCommon__text__mob
                                            : contactUsStyle.centercontentCommon__text__web
                                    )}
                                >
                                    {t("contactus:for_general_queries")}:
                                    <span className={classnames(contactUsStyle.centercontentCommon__span)}>
                                        cs@vahak.in
                                    </span>
                                </div>
                            </A>
                        </div>
                        {isMobile ? (
                            <div
                                style={{
                                    backgroundColor: "#E9E9E9",
                                    height: "1px",
                                    width: "100%",
                                    marginTop: "26px",
                                    marginBottom: "26px"
                                }}
                            ></div>
                        ) : (
                            <div
                                style={{
                                    backgroundColor: "#E9E9E9",
                                    height: "60px",
                                    width: "1px",
                                    marginLeft: "45px",
                                    marginRight: "45px"
                                }}
                            ></div>
                        )}
                        <h3>
                            <A onClick={onClickEmail_Info}>
                                {t("contactus:for_partnerships")} <br /> {t("contactus:related_queries")}:{" "}
                                <span className={classnames(contactUsStyle.centercontentCommon__span)}>
                                    info@vahak.in
                                </span>
                            </A>
                        </h3>
                    </div>
                </div>
                <section
                    className={classnames(
                        isMobile ? contactUsStyle.locationMargin__mob : contactUsStyle.locationMargin__web
                    )}
                >
                    <Located />
                </section>
            </div>

            {/* Callback Request Popup */}
            {
                <CallbackRequest
                    isCallbackRequestPopupVisible={!!router.asPath.includes(CONTACT_US_CALL_BACK_REQUEST)}
                    toggleCallBackRequestModal={toggleCallBackRequestModal}
                    onSubmit={function () {
                        closeLoadBidModal();
                    }}
                    sourceScreen={CallMeBackScreen.CONTACT_US}
                />
            }
        </>
    );
};

export default ContactUsComponent;
